import request from '@/utils/request'
//获取验证码
export function getCode(data) {
  return request({
    url: '/resources/getCode',
    method: 'get',
    params:data
  })
}
//登录
export function login(data) {
  return request({
    url: '/resources/login',
    method: 'post',
    data
  })
}

export function tokenLogin(data) {
  return request({
    url: '/resources/tokenLogin',
    method: 'get',
    params: data
  })
}


// 账号检测
export function loginType(params) {
  return request({
    url: '/resources/loginType',
    method: 'get',
    params
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/resources/change',
    method: 'post',
    data
  })
}